
import BaseSection from "@/components/base/BaseSection.vue";
import BookingDepartureDate from "@/components/bookingflow/steps/departure/BookingDepartureDate.vue";
import DepartureHeader from "@/components/bookingflow/steps/departure/DepartureHeader.vue";
import BookingDepartureList from "@/components/bookingflow/steps/departure/DepartureList.vue";
import { validDeparture } from "@/composables/useBookingValidation";
import useDepartures from "@/composables/useDepartures";
import { DirectionEnum } from "@/models/enums";
import { DeparturePrice } from "@/models/www/DeparturePrice";
import { useBookingStore } from "@/store/booking";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, defineComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";


export default defineComponent({
    components: {
        BaseSection,
        DepartureHeader,
        BookingDepartureDate,
        BookingDepartureList
    },
    props: {
        loading: Boolean,
        departures: {
            type: Array as PropType<DeparturePrice[]>,
            default: () => []
        },
        direction: {
            type: Number as PropType<DirectionEnum>,
            required: true
        },
        forceEnabled: Boolean,
    },
    setup(props) {
        const bookingStore = useBookingStore();
        const { outwardArrivalDate, returnDepartureDate } = useDepartures();
        const { t } = useI18n();

        const disableList = computed(() => {
            const identifier = bookingStore.getDeparture(DirectionEnum.Outward)?.identifier;
            return props.forceEnabled !== true && (identifier?.length === 0 || identifier === undefined) &&
            				props.direction === DirectionEnum.Return;
        });

				const validOutward = () => {
						
				    if (props.direction !== DirectionEnum.Outward) {
            		return true;
          	}
          	
          	const departure = bookingStore.getDeparture(DirectionEnum.Outward);
          	return departure.identifier.length > 0;
        	
				};
				
        const validReturn = () => {
            
            if (props.direction !== DirectionEnum.Return) {
            		return true;
          	}
          	
          	const departure = bookingStore.getDeparture(DirectionEnum.Return);
          	return departure.identifier.length > 0;
        }
        
        const validReturnDate = () => {
            const departureDateReturn = validReturn() ? bookingStore.getDate(DirectionEnum.Return) : false;
            
            if (departureDateReturn && 
            		props.direction === DirectionEnum.Return) {
            			
                //clear departure if outward arrival date
                //is after the return departure date
                if(outwardArrivalDate.value > returnDepartureDate.value) {
                    return false;
                }

                return true;
            }
            
            return true;
        }
     

        const rules = {
					departure: {
					 v: helpers.withMessage(
							() => t("validation.departure.required"),
								validOutward as any
							),
						v2: helpers.withMessage(
							() => t("validation.departure.invalidReturnDate"),
								validReturnDate as any
							),
						v3: helpers.withMessage(
							() => t("validation.departure.invalidReturn"),
							validReturn as any
						)
					}
				};
				
        const fromDestination = computed(() => {
            return bookingStore.getRoute(props.direction).substring(0, 3);
        });

        const toDestination = computed(() => {
            return bookingStore.getRoute(props.direction).substring(3, 6);
        });

		const v$ = useVuelidate(rules, { departure: computed(() => { return bookingStore.getDeparture(props.direction)}) });

        return { v$, fromDestination, toDestination, disableList }
    }
})
